export default __webpack_public_path__ + "static/trackthebat11-cd5192a18334b43ee6e8e8b940e572db.jpeg";